import React, { FC } from 'react';
import Icon from '@ant-design/icons';
import { IconProps } from 'ui/components/Icon';

const DeleteSVG = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20.9999 6.73C20.9799 6.73 20.9499 6.73 20.9199 6.73C15.6299 6.2 10.3499 6 5.11992 6.53L3.07992 6.73C2.65992 6.77 2.28992 6.47 2.24992 6.05C2.20992 5.63 2.50992 5.27 2.91992 5.23L4.95992 5.03C10.2799 4.49 15.6699 4.7 21.0699 5.23C21.4799 5.27 21.7799 5.64 21.7399 6.05C21.7099 6.44 21.3799 6.73 20.9999 6.73Z'
      fill='currentColor'
    />
    <path
      d='M8.49992 5.72C8.45992 5.72 8.41992 5.72 8.36992 5.71C7.96992 5.64 7.68992 5.25 7.75992 4.85L7.97992 3.54C8.13992 2.58 8.35991 1.25 10.6899 1.25H13.3099C15.6499 1.25 15.8699 2.63 16.0199 3.55L16.2399 4.85C16.3099 5.26 16.0299 5.65 15.6299 5.71C15.2199 5.78 14.8299 5.5 14.7699 5.1L14.5499 3.8C14.4099 2.93 14.3799 2.76 13.3199 2.76H10.6999C9.63991 2.76 9.61992 2.9 9.46992 3.79L9.23992 5.09C9.17992 5.46 8.85992 5.72 8.49992 5.72Z'
      fill='currentColor'
    />
    <path
      d='M15.2099 22.75H8.78992C5.29992 22.75 5.15992 20.82 5.04992 19.26L4.39992 9.19C4.36992 8.78 4.68992 8.42 5.09992 8.39C5.51992 8.37 5.86992 8.68 5.89992 9.09L6.54992 19.16C6.65992 20.68 6.69992 21.25 8.78992 21.25H15.2099C17.3099 21.25 17.3499 20.68 17.4499 19.16L18.0999 9.09C18.1299 8.68 18.4899 8.37 18.8999 8.39C19.3099 8.42 19.6299 8.77 19.5999 9.19L18.9499 19.26C18.8399 20.82 18.6999 22.75 15.2099 22.75Z'
      fill='currentColor'
    />
    <path
      d='M13.6599 17.25H10.3299C9.91992 17.25 9.57992 16.91 9.57992 16.5C9.57992 16.09 9.91992 15.75 10.3299 15.75H13.6599C14.0699 15.75 14.4099 16.09 14.4099 16.5C14.4099 16.91 14.0699 17.25 13.6599 17.25Z'
      fill='currentColor'
    />
    <path
      d='M14.4999 13.25H9.49992C9.08992 13.25 8.74992 12.91 8.74992 12.5C8.74992 12.09 9.08992 11.75 9.49992 11.75H14.4999C14.9099 11.75 15.2499 12.09 15.2499 12.5C15.2499 12.91 14.9099 13.25 14.4999 13.25Z'
      fill='currentColor'
    />
  </svg>
);

export const DeleteOutline: FC<IconProps> = props => <Icon component={DeleteSVG} {...props} />;
